import { render, staticRenderFns } from "./PreguntaForm.vue?vue&type=template&id=0e050d68&"
import script from "./PreguntaForm.vue?vue&type=script&lang=js&"
export * from "./PreguntaForm.vue?vue&type=script&lang=js&"
import style0 from "./PreguntaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports